"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.env = exports.ENVIRONMENT_VARIABLE_NAMES = exports.ENVIRONMENT = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ENVIRONMENT_VARIABLE;

var ENVIRONMENT = {
  STAGING: 'int',
  PRODUCTION: 'prd'
};
exports.ENVIRONMENT = ENVIRONMENT;
var ENVIRONMENT_VARIABLE_NAMES = {
  REACT_APP_FULFILLER_IDENTITY_BASE_URL: 'REACT_APP_FULFILLER_IDENTITY_BASE_URL',
  REACT_APP_NALA_ENBED_URL: 'REACT_APP_NALA_ENBED_URL',
  REACT_APP_CUSTOMIZR_BASE_URL: 'REACT_APP_CUSTOMIZR_BASE_URL',
  REACT_APP_CUSTOMIZR_SAVED_SEARCH: 'REACT_APP_CUSTOMIZR_SAVED_SEARCH',
  REACT_APP_MERCHANT_CONFIG_BASE_URL: 'REACT_APP_MERCHANT_CONFIG_BASE_URL',
  REACT_APP_FULFILLMENT_LOCATION_BASE_URL: 'REACT_APP_FULFILLMENT_LOCATION_BASE_URL'
};
exports.ENVIRONMENT_VARIABLE_NAMES = ENVIRONMENT_VARIABLE_NAMES;
var ENVIRONMENT_VARIABLES = (_ENVIRONMENT_VARIABLE = {}, (0, _defineProperty2["default"])(_ENVIRONMENT_VARIABLE, ENVIRONMENT.STAGING, {
  REACT_APP_FULFILLER_IDENTITY_BASE_URL: 'https://fulfilleridentity.staging.trdlnk.cimpress.io',
  REACT_APP_NALA_ENBED_URL: 'https://nala.cimpress.io/v1/embed/generateLink',
  REACT_APP_CUSTOMIZR_BASE_URL: 'https://customizr.at.cimpress.io',
  REACT_APP_CUSTOMIZR_SAVED_SEARCH: 'FulfillerHealth-savedSearch',
  REACT_APP_MERCHANT_CONFIG_BASE_URL: 'https://int-merchant-config.commerce.cimpress.io',
  REACT_APP_FULFILLMENT_LOCATION_BASE_URL: 'https://fulfillmentlocation.trdlnk.cimpress.io'
}), (0, _defineProperty2["default"])(_ENVIRONMENT_VARIABLE, ENVIRONMENT.PRODUCTION, {
  REACT_APP_FULFILLER_IDENTITY_BASE_URL: 'https://fulfilleridentity.trdlnk.cimpress.io',
  REACT_APP_NALA_ENBED_URL: 'https://nala.cimpress.io/v1/embed/generateLink',
  REACT_APP_CUSTOMIZR_BASE_URL: 'https://customizr.at.cimpress.io',
  REACT_APP_CUSTOMIZR_SAVED_SEARCH: 'FulfillerHealth-savedSearch',
  REACT_APP_MERCHANT_CONFIG_BASE_URL: 'https://merchant-config.commerce.cimpress.io',
  REACT_APP_FULFILLMENT_LOCATION_BASE_URL: 'https://fulfillmentlocation.trdlnk.cimpress.io'
}), _ENVIRONMENT_VARIABLE);

var env = function env(key) {
  var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ENVIRONMENT.PRODUCTION;
  return ENVIRONMENT_VARIABLES[env] && ENVIRONMENT_VARIABLES[env][key];
};

exports.env = env;